// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YNcL","colBig":"styles_colBig__tgLyl","colSmall":"styles_colSmall__1s-uJ"};